<main>
  <div class="content">
  </div>
</main>
<!-- system詢問user:有沒有用其它e-mail註冊過PPC服務 -->
<p-dialog header="{{'Alert' | translate}}" [(visible)]="socialEmailRegisterSetting" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content flex-none">
    <div class="form-group">
      <label for="" class="col-form-label" translate>Please select your location</label>
      <div class="select">
        <p-select [options]="CountryOptions" [(ngModel)]="Country" name="Country" #country="ngModel" required appendTo="body"></p-select>
      </div>
    </div>
    <div translate class="alert alert-warning">
      The registration process will be terminated if you click cancel now.
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="registerAccountSettingSave();" class="{{Confirm_button}}" [disabled]="checkRegisterAccountSave()"></button>
    <button type="button" pButton label="{{'Cancel' | translate}}" (click)="registerAccountSettingCancel();" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<!-- system跳視窗請user輸入OTP -->
<p-dialog header="{{'Two-Factor Authentication' | translate}}" [(visible)]="TwoFactorAuthDialog" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="true" (onHide)="closeDialog()">
  <div class="dialog-content">
    <div class="content-info center auth">
      <span class="fa-stack fa-lg">
        <span class="material-icons fa-stack-2x shield">
          shield
        </span>
        <span class="material-icons fa-stack-1x key">
          key
        </span>
      </span>
      <h5 translate>Please enter OTP shown in PowerPanel Cloud APP and your e-mail</h5>
      <p-inputMask mask="999999" [(ngModel)]="OTPNumber" [ngClass]="{'ng-validDirty': dialogSaveDirty}" [disabled]="OTPOvertime" (keyup.enter)="OTPkeyupEnter($event);" (ngModelChange)="OTPNumberOnchange($event)"></p-inputMask>
      <p-message severity="error" *ngIf="dialogSaveDirty"></p-message>
      <p [ngClass]="{'message-error': OTPOvertime}">
        <span *ngIf="OTPOvertime else OTPOvertimeTrue">{{errorMsg | translate}} <br><span *ngIf="errorMsgByLock">{{'Please wait for 3 minutes before you try again.' | translate}}</span></span>
        <span class="time">
          <countdown #countdown [config]="config" (event)="handleEvent($event)"></countdown>
        </span>
      </p>
      <ng-template #OTPOvertimeTrue>
        <p style="color:red;font-weight: bolder;">{{errorMsg | translate}}</p>
        <p translate>OTP will expire in</p>
      </ng-template>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Submit' | translate}}" (click)="confrimOTPnumber();" class="{{Confirm_button}}" *ngIf="!OTPOvertime" [disabled]="OTPNumberSubmitDisabled"></button>
    <button type="button" pButton label="{{'Close' | translate}}" (click)="closeDialog();" class="{{Confirm_button}}" *ngIf="OTPOvertime"></button>
  </ng-template>
</p-dialog>

<!-- OTP system跳錯誤訊息:*帳號鎖住3分鐘後才能重送OTP -->
<p-dialog header="{{'Alert' | translate}}" [(visible)]="OTPLockDialog" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-times-circle critical"></i>
    </div>
    <div class="content-info">
      <p translate>The OTP is no longer valid for entering because it has been submitted falsely for 5 times.</p>
      <br>
      <p translate>Please wait for 3 minutes before you try again.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog();" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>

<!-- AFG被綁定 -->
<p-dialog header="{{'Alert' | translate}}" [(visible)]="socialAccountCombineLimitAlert" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content align-items-top">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info">
      <p translate>You have used the other social account to combine with the PowerPanel Cloud account.</p>
      <p translate>Please log in to your PowerPanel Cloud account and cancel the combination first if you want to combine this social account with the PowerPanel Cloud account.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" class="{{Confirm_button}}" (click)="socialAccountCombineLimitAlert=false"></button>
  </ng-template>
</p-dialog>

<!-- Email被綁定 -->
<p-dialog header="{{'Alert' | translate}}" [(visible)]="socialAccountEmailAlert" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content align-items-top">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info">
      <p>{{'The e-mail address censoredEmail has alrady been registered for an PowerPanel Cloud account._1' | translate}} <span class="strong">{{censoredEmail}}</span> {{'The e-mail address censoredEmail has alrady been registered for an PowerPanel Cloud account._2' | translate}} </p>
      <p translate>Please log in to your PowerPanel Cloud account and go to Account page to combine the social account.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" class="{{Confirm_button}}" (click)="socialAccountEmailAlert=false"></button>
  </ng-template>
</p-dialog>